import { render } from "./RechargeRecord.vue?vue&type=template&id=198a2fff&scoped=true"
import script from "./RechargeRecord.vue?vue&type=script&lang=js"
export * from "./RechargeRecord.vue?vue&type=script&lang=js"

import "./RechargeRecord.vue?vue&type=style&index=0&id=198a2fff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198a2fff"]])

export default __exports__